'use strict';

var PreviewCarouselView = require('./PreviewCarouselView'),

  ImageSliderView = PreviewCarouselView.extend({

    events: {
      'click .ThumbnailCarousel-counter': 'toggleThumbnails'
    },

    initialize: function() {

      ImageSliderView.__super__.initialize.apply(this, arguments);

      // Creates carousel for the main component
      this.addMainCarousel(this.$('.ImageCarousel-carousel'));

      // Creates carousel for thumbnails
      this.addThumbnailCarousel(this.$('.ThumbnailCarousel-carousel'));

      // Creates counter
      this.addCounter(this.$('.ThumbnailCarousel-counter'));

    },

    toggleThumbnails: function() {
      this.$el.toggleClass('show-thumbnails');
      if (this.$el.hasClass('show-thumbnails')) {
        this.$('button.Icon.Icon--grid').attr('aria-expanded', true);
      }
      else {
        this.$('button.Icon.Icon--grid').attr('aria-expanded',false);
      }
    }

  }, {
    create: function($parent) {
      $parent.find('.ImageSlider').each(function(n, el) {
        new ImageSliderView({
          el: el,
          collapsibleThumbnail: true
        });
      });
    }
  });

module.exports = ImageSliderView;



// WEBPACK FOOTER //
// ./assets/js/components/carousel/ImageSliderView.js